import { Link } from "react-router-dom";
import { ArrowRight, Package, Users, BookOpenCheck } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";
import { Button } from "@/components/ui/button";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#F9F8F6] text-slate-900 relative overflow-hidden">
      <header className="sticky top-0 z-30 backdrop-blur-md bg-white/70 border-b border-[#E2DDD5]">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <BrandMark />
            <div>
              <div className="font-bold tracking-tight">GoWeb Reseller</div>
              <div className="text-[10px] uppercase tracking-wider text-slate-500 font-mono">reseller.goweb.srl</div>
            </div>
          </div>
          <nav className="flex items-center gap-3">
            <Link to="/sign-in" data-testid="landing-cta-signin">
              <Button className="bg-[#B84A2B] hover:bg-[#983C21] text-white">Accedi al portale <ArrowRight size={14} className="ml-1" /></Button>
            </Link>
          </nav>
        </div>
      </header>

      <section className="relative max-w-6xl mx-auto px-6 pt-20 pb-16">
        <div className="absolute right-[-100px] top-[40px] w-[460px] h-[460px] rounded-full bg-[#C69214]/15 blur-3xl -z-0" />
        <div className="absolute left-[-120px] top-[260px] w-[360px] h-[360px] rounded-full bg-[#B84A2B]/10 blur-3xl -z-0" />

        <div className="relative z-10 max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-white border border-[#E2DDD5] rounded-full px-3 py-1 text-xs text-slate-600">
            <span className="w-1.5 h-1.5 rounded-full bg-[#206342]" />
            Portale ufficiale GoWeb Srl Semplificata
          </div>
          <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
            Gestisce i rivenditori<br/>
            <span className="text-[#B84A2B]">come un'opera di sartoria.</span>
          </h1>
          <p className="mt-5 text-base sm:text-lg text-slate-600 max-w-2xl">
            Un unico portale per onboarding rivenditori, listini prodotti, piani provvigionali, moduli d'ordine firmati e integrazione API bidirezionale con Booking Hub e Cantiere 360 Cloud.
          </p>
          <div className="mt-8 flex items-center gap-3">
            <Link to="/sign-in" data-testid="hero-cta-signin">
              <Button size="lg" className="bg-[#B84A2B] hover:bg-[#983C21] text-white">Accedi</Button>
            </Link>
            <Link to="/sign-up" data-testid="hero-cta-signup">
              <Button size="lg" variant="outline" className="border-[#E2DDD5]">Diventi rivenditore</Button>
            </Link>
          </div>
        </div>

        <div className="relative z-10 grid grid-cols-1 md:grid-cols-3 gap-4 mt-16">
          {[
            { icon: Users, title: "Rivenditori", body: "Anagrafiche fiscali complete, moduli d'identità, visura e accordo firmato in un flusso guidato." },
            { icon: Package, title: "Catalogo prodotti", body: "Booking Hub, Cantiere 360 Cloud e nuove soluzioni GoWeb — assegnabili per singolo rivenditore." },
            { icon: BookOpenCheck, title: "API bidirezionali", body: "Il portale comunica con i prodotti per attivare account, rinnovi, cambi piano e disattivazioni." },
          ].map((f, i) => (
            <div key={i} className="bg-white border border-[#E2DDD5] rounded-xl p-5 shadow-sm hover:shadow-md transition-all">
              <div className="w-9 h-9 rounded-lg bg-[#F2F0EB] text-[#B84A2B] flex items-center justify-center">
                <f.icon size={18} />
              </div>
              <div className="mt-4 font-semibold">{f.title}</div>
              <div className="text-sm text-slate-600 mt-1 leading-relaxed">{f.body}</div>
            </div>
          ))}
        </div>
      </section>

      <footer className="border-t border-[#E2DDD5] mt-16">
        <div className="max-w-6xl mx-auto px-6 py-6 text-xs text-slate-500 flex items-center justify-between">
          <div>© GoWeb Srl Semplificata — Tutti i diritti riservati</div>
          <div className="font-mono">v1.0 · reseller.goweb.srl</div>
        </div>
      </footer>
    </div>
  );
}
